import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { App } from "./web";
import { store } from "./core/redux";
import { DependencySentinelClient } from "@amzn/dependencysentinel";
import { getSentinelConfig } from "./core/sentinel/config";
import "./index.scss";
document.addEventListener("DOMContentLoaded", async () => {
    const container = document.getElementById("root");
    const root = createRoot(container!);
    const { getAuthConfig } = await import("./core/config");
    const { logging } = await import("./core/util/log");
    const { AuthController, SentinelController } = await import("./core/controller");
    const authConfig = getAuthConfig(location.host);
    const authController = new AuthController({
        authConfig,
    });
    try{
        const sentinelConfig = getSentinelConfig(location.host);
        logging.log("Sentinel Client Config", JSON.stringify(sentinelConfig));
        const credentials =
          await authController.getCredentialsProvider(sentinelConfig);
        logging.log("Sentinel Credentials", credentials);
        const userIdentity = await authController.getUserIdentity();
        logging.log(`Fetched user identity: ${userIdentity.username}`);
        const sentinelClient = new DependencySentinelClient({
            region: (sentinelConfig.httpSigning as any).region,
            endpoint: sentinelConfig.httpEndpoint?.url,
            credentials: credentials,
        });
        const sentinelController = new SentinelController({
            userIdentity,
            sentinelClient,
        });
        logging.log(`Fetched user identity..: ${userIdentity.username}`);
        root.render(
            <Provider store={store}>
                <App sentinelController={sentinelController}/>
            </Provider>
        );
    } catch (error) {
	     logging.error("authentication error, typically we redirect", error);
	   }
});